<template>
    <EditModal
        id="notenausgabeSVModal"
        title="Noten an Stimmvetreter ausgeben"
        :busy="busy"
        size="xl"
        buttonText="Ausgeben"
        scrollable
        @ok="dataProvide"
        @hidden="dataHide"
    >
        <NotenausgabeSV
            :svId="svId"
            :werkId="werkId"
            :notenId="notenId"
            :notentyp="notentyp"
            :validationData="validationData"
            @update="updateNotenausgabe"
        />
    </EditModal>
</template>

<script>
import EditModal from "@/components/EditModal/EditModal";
import NotenausgabeSV from "@/components/Notentransfer/NotenausgabeSV";
import Toaster from "@/mixins/Toaster/Toaster";

export default {
    name: "NotenausgabeSVModal",
    mixins: [Toaster],
    components: { EditModal, NotenausgabeSV },
    props: ["svId", "werkId", "notenId", "notentyp", "busy", "validationData"],
    data() {
        return {
            data: null
        };
    },
    methods: {
        async dataProvide(evt) {
            evt.preventDefault();
            this.$emit("success", this.data);
        },
        dataHide() {
            this.dataCancel();
        },
        dataCancel() {
            this.data = null;
        },
        updateNotenausgabe(data) {
            this.data = data;
        }
    }
};
</script>